import { render, staticRenderFns } from "./Youtubevideo.vue?vue&type=template&id=ed010a30&scoped=true&"
import script from "./Youtubevideo.vue?vue&type=script&lang=js&"
export * from "./Youtubevideo.vue?vue&type=script&lang=js&"
import style0 from "./Youtubevideo.vue?vue&type=style&index=0&id=ed010a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed010a30",
  null
  
)

export default component.exports